import {Component} from "react";
import "./FooterStyles.css"

class Footer extends Component {

    constructor() {
        super();
    }

    render() {
        const doc = window.location.origin + "/documents/privacy-policy.pdf";
        return (
            <div className={"footer"}>
                <div className={"footer-icons-box"}>
                    <div className={"footer-icon"}>
                        <a href={'https://vk.com/sfr'}><img
                            src={process.env.PUBLIC_URL + '/icons/header/vk.svg'}/></a>
                    </div>
                    <div className={"footer-icon"}>
                        <a href={'https://t.me/sfr_gov'}><img
                            src={process.env.PUBLIC_URL + '/icons/header/tg.svg'}/></a>
                    </div>
                    <div className={"footer-icon"}>
                        <a href={'https://ok.ru/sfr'}><img src={process.env.PUBLIC_URL + '/icons/header/ok.svg'}/></a>
                    </div>
                </div>
                <div className={"footer-item"}>
                    <a href={doc} download={"privacy-policy.pdf"} target={"_blank"}>Политика конфиденциальности</a>
                </div>
                <div className={"footer-item"}>
                    <a href={"https://sfr.gov.ru/"}>Социальный фонд России</a>
                </div>
                <div className={"footer-item"}>
                    <a href={""} onClick={() => window.location = 'mailto:sn-support@fss.ru'}>Техническая поддержка
                        приложения</a>
                </div>
            </div>
        );

    }
}

export default Footer;